import { UseBaseQueryResult, useQuery } from 'react-query';
import { Site } from 'sections/client-management/entities';
import { siteQuery } from 'sections/queries/queries';

export const useSite = (siteId: string): UseBaseQueryResult<Site> => {
  return useQuery(['siteById', siteId], () => siteQuery(siteId));
};
